import { ListItem, ListItemText } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import TimelineDots from '@components/accountStatements/TimelineDots';

const NoTransactions = () => {
    return (
        <ListItem sx={{ pl: 2 }} data-testid="no-transactions-component">
            <TimelineDots />
            <ListItemText
                sx={{ ml: 2 }}
                primary={
                    <FormattedMessage
                        id="AccountStatements.noTransactions"
                        defaultMessage="No transactions"
                    />
                }
                secondary={
                    <FormattedMessage
                        id="AccountStatements.noTransactionsMessage"
                        defaultMessage="No transactions were found during this statement period"
                    />
                }
            />
        </ListItem>
    );
};

export default NoTransactions;
